import styled from "styled-components";

import { Box } from "@similarweb/ui-components/foundations";

export const SpacedTableContentContainer = styled(Box)`
    & th::before {
        content: none !important;
    }

    & tr:last-child > td {
        border-bottom: none;
    }
`;
